<template>
  <div class="metric-card">
    <div class="metric-icon"><vue-feather :type="card.icon" class="metric-feather"></vue-feather></div>
    <div class="metric-content">
      <span class="metric-label">{{ card.title }}</span>
      <strong class="metric-value">{{ card.value }}</strong>
      <small class="metric-note" :class="card.noteTone">{{ card.note }}</small>
      <small v-if="card.formula" class="metric-formula">{{ card.formula }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "MetricCard",
  props: {
    // { title, value, note, noteTone, icon, formula? } from dashboardCards.js
    card: { type: Object, required: true },
  },
};
</script>
